import { Component, OnDestroy, OnInit, EventEmitter, Input, Output, ViewContainerRef, OnChanges } from '@angular/core';
import { DemoService } from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Routes, RouterModule, Router } from '@angular/router';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import { Observable, Subject } from 'rxjs';

import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { LegalDateTimeService } from '../../../services/legal-datetime.service';

@Component({
  selector: 'app-client-job-create-wizard-step2',
  templateUrl: './client-job-create-wizard-step2.component.html',
  styleUrls: ['./client-job-create-wizard-step2.component.scss']
})
export class ClientJobCreateWizardStep2Component implements OnInit {

// public today = Date.now();
public today = this.gfunc.todayDate;

  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  job: any;
  JobStep2ID: any;
  model: any;
  job_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  clients: any;
  client_contacts: any;
  sent_client_id: any;
  positionsMysql: any;
  get_subjects: any;
  job_subject_types: any;
  job_plaintiff_types: any;
  sessionUsername: any;
  hide_content_from_client: number;
  current_subject_count: any;
  subjects: Object;
  jobDatePickerValues: { [key: string]: { [field: string]: Date | null } } = {};
  private readonly legalJobDateFields = ['judgement_date', 'filing_date', 'hearing_date', 'instructions_date'];

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
    vcr: ViewContainerRef, private router: Router,
    public gfunc: GlobalFunctionsService,
    public legalDate: LegalDateTimeService
  ) {

    this.nav = document.querySelector('nav.navbar');
   

    // login vars
    // this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
    // console.log('sessionUserId: ', this.currentUserVAR.user_id);
    // console.log('sessionUsername: ', this.currentUserVAR.username);
    // // Set loggind in User Value (USER ID)
    // this.sessionUserId = this.currentUserVAR.user_id;
    // this.sessionUserId = this.currentUserVAR.username;
    // this.sessionBrandId = this.currentUserVAR.brand_id;
  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;


  }

  ngOnInit() {
    this.JobStep2ID = +this.route.snapshot.paramMap.get('job_id');

    this.getJob(this.JobStep2ID);
    this.getJobSubjects(this.JobStep2ID) // check to create a 1st subject or not.
    this.getJobTypes();
    this.getPositions();
    // this.getJobTypeLocations(this.model.job_type_location_id); // loads default locations as nothing
    this.getJobSubjectTypes();
    this.getJobPlaintiffTypes();

    this.hide_content_from_client = 0;
    if (this.router.url.includes('/client/jobs/create-job-wizard-step-')) {
      this.hide_content_from_client = 1;
      console.log('We are on client page  - create job')
    } else {
      //  return '';
    }


  }



  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
      data => {
        this.job = data;
        let res = data[0];
        this.initializeJobDatePickerValues(this.job);
        // Need to load the drop downs (only if a process is selected.)
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
        this.getJobTypeAffidavitTypes(res.job_type_document_type_id);

      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobDateKey(model: any): string {
    return String(model?.job_id ?? '');
  }

  getJobDatePickerValue(model: any, field: string): Date | null {
    const key = this.getJobDateKey(model);
    return this.jobDatePickerValues[key]?.[field] ?? null;
  }

  onJobDateChange(field: string, value: unknown, model: any): void {
    const key = this.getJobDateKey(model);
    const pickerDate = this.legalDate.coercePickerDate(value);

    if (!this.jobDatePickerValues[key]) {
      this.jobDatePickerValues[key] = {};
    }

    this.jobDatePickerValues[key][field] = pickerDate;
    model[field] = this.legalDate.fromPickerDate(pickerDate);
  }

  private initializeJobDatePickerValues(jobs: any[]): void {
    if (!Array.isArray(jobs)) {
      this.jobDatePickerValues = {};
      return;
    }

    const jobDatePickerValues: { [key: string]: { [field: string]: Date | null } } = {};

    jobs.forEach((jobModel) => {
      const key = this.getJobDateKey(jobModel);
      jobDatePickerValues[key] = {};

      this.legalJobDateFields.forEach((field) => {
        jobDatePickerValues[key][field] = this.legalDate.toPickerDate(jobModel?.[field]);
      });
    });

    this.jobDatePickerValues = jobDatePickerValues;
  }


  // BOF SHARMANS CALLS
  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
      data => { this.job_types = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getJobSubjectTypes() {
    this._demoService.getJobSubjectTypes().subscribe(
      data => { this.job_subject_types = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobPlaintiffTypes() {
    this._demoService.getJobPlaintiffTypes().subscribe(
      data => { this.job_plaintiff_types = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
      data => { this.job_type_locations = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....



    console.log('sending Count:' + this.count2);
  }


  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
      data => { this.job_type_courts = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....



    console.log('sending Location:' + this.sent_job_type_location_id);
  }


  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
      data => { this.job_type_document_types = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....


    console.log('sending Court Type:' + this.sent_job_type_court_id);
  }


  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
      data => { this.job_type_affidavit_types = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....

    console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }



  getClients() {
    this._demoService.getClients().subscribe(
      data => { this.clients = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getClientContactsSharmans(client_id) {
    this._demoService.getClientContactsSharmans(client_id).subscribe(
      data => { this.client_contacts = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  sendClientID(client_id) {
    this.sent_client_id = client_id;
    this.getClientContactsSharmans(this.sent_client_id); // updates the selected job ID....

    console.log('sending Client ID:' + this.sent_client_id);
  }

  private getPositions() {
    this._demoService.getPositions()
      .subscribe(
        res => this.positionsMysql = res,
        err => console.error(err.status)
      );
  }



  // update was here for onit but moved for onchange
  updateJobStep2(model) {
    model.number_subjects = 1;

model.updated_date = this.gfunc.todayDate
model.updated_by = this.gfunc.sessionUserId

    this._demoService.updateJobStep2(model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        this.toastr.success('Job Updated');
    
    
        // fix for back button and only create a subject if one does not already exists
          if(this.current_subject_count < 1){
          // This function needs to have missing Fiels Added or not create the subject at all.....
          this.createJobSubjectsMultiple(model); // this function creates the subjects for the job
          }
    
    // Subject to reload the manager component parent.
        // TraceCandidateManagerComponent.returned.next(false);
        // this.router.navigate(['/client/jobs/create-job-step-3/' + model.job_id + '']);

        this.router.navigate(['/client/jobs/create-job-wizard-step-3/' + model.job_id + '']);
        return true;
      },
      error => {
        // console.error('Error saving Event!');
        this.toastr.error('Error saving Job!');
       return console.log(error);
      }
      // err => console.error(err),
      // () => console.log('done updates')
    );
  }



  // create subjects
  createJobSubjectsMultiple(model) {

    // I have now modified this function to carry across job type ids in the insert scrupt to the subject.

    this._demoService.createJobSubjectsMuliple(model).subscribe(
      data => {
        this.get_subjects = data; // this is the retuned json upon creation.
        this.toastr.success('Subjects Saving... We have added your subject(s).');
        // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

        // Setup annd the Currents before we redirec the page
        // Needs to be a Function to update the ObserveOnOperator.
        // this.newCTrace_id(this.latest_trace_id);
        // or this.cdata.changeCTrace_id("999");

        // this.router.navigate(['/admin/jobs/create-job-2/' + model.job_id + '']);

        return true;


      },
      error => {
        // console.log('Should be form Model' + model);
        // console.error('Error Creating a Trace Project!');
        // this.toastr.error('Adding Subjects Failed :: Please try again!');
        // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
    );
  }


  // check if there is subjects before creation
    getJobSubjects(job_id) {
    this._demoService.getJobSubjects(job_id).subscribe(
      data => {
        this.subjects = data;
        let res = data[0];

        this.current_subject_count = Object(this.subjects).length; // counts the subjects.
        // this.getSubjectNotes(res.subject_id);
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


}

// Allows formatting of dates etc...
export class DatePipeComponent {
  today: number = Date.now();
  fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
  // tslint:disable-next-line:eofline
}
